'use client';

import { useEffect } from 'react';
import { track } from '@/lib/analytics/ym';

export function ScrollDepth() {
  useEffect(() => {
    let fired50 = false;
    let fired90 = false;

    function onScroll() {
      const scrolled = window.scrollY;
      const max = document.documentElement.scrollHeight - window.innerHeight;
      if (max <= 0) return;
      const percent = (scrolled / max) * 100;
      if (!fired50 && percent >= 50) {
        fired50 = true;
        track.scrollDepth(50);
      }
      if (!fired90 && percent >= 90) {
        fired90 = true;
        track.scrollDepth(90);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return null;
}
